var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLateillustrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 715,
    height: 402,
    viewBox: "0 0 715 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_1158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.64 196.996H540.633V259.142H606.64V196.996Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.733 120.031V149.937H401.985C382.418 149.937 366.552 165.798 366.552 185.369V120.031H444.733Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.779 93.332L266.431 120.033L174.253 120.075V120.033H174.276L204.625 93.332H296.779Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.644 309.571V381.295H93.2368V213.143L174.253 157.589V120.073H266.431V120.029L316.493 75.9844L366.556 120.029V185.365C366.556 165.796 382.419 149.933 401.989 149.933C421.558 149.933 437.421 165.794 437.421 185.365V196.943C457.251 193.899 475.773 179.088 489.517 149.935C498.968 169.991 510.123 182.746 522.579 190.093C528.167 193.389 534.268 195.721 540.63 196.993V259.138L605.645 309.571H671.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.633 259.141H606.64L671.651 309.575H605.645L540.633 259.141Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.511 149.941C475.768 179.092 457.246 193.897 437.415 196.947V185.37C437.415 165.802 421.553 149.938 401.983 149.938L489.511 149.941Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.633 149.935V113.148",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.854 120.031H548.076",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.833 123.445H548.075",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.388 131.546C325.715 131.546 331.655 125.606 331.655 118.279C331.655 110.952 325.715 105.012 318.388 105.012C311.061 105.012 305.121 110.952 305.121 118.279C305.121 125.606 311.061 131.546 318.388 131.546Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.065 128.065C323.392 128.065 329.332 122.126 329.332 114.798C329.332 107.471 323.392 101.531 316.065 101.531C308.738 101.531 302.798 107.471 302.798 114.798C302.798 122.126 308.738 128.065 316.065 128.065Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.065 101.531V128.065",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.33 114.793H302.798",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.651 72.7227V100.947C256.651 102.461 256.049 103.914 254.978 104.985C253.907 106.056 252.455 106.658 250.94 106.658C249.426 106.657 247.974 106.055 246.904 104.984C245.834 103.913 245.232 102.461 245.232 100.947V72.7227C245.232 74.2373 245.834 75.6899 246.905 76.7609C247.976 77.8319 249.429 78.4336 250.943 78.4336C252.458 78.4336 253.911 77.8319 254.982 76.7609C256.053 75.6899 256.654 74.2373 256.654 72.7227H256.651Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.943 78.4337C254.097 78.4337 256.654 75.8768 256.654 72.7227C256.654 69.5686 254.097 67.0117 250.943 67.0117C247.789 67.0117 245.232 69.5686 245.232 72.7227C245.232 75.8768 247.789 78.4337 250.943 78.4337Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.329 106.031L270.437 93.332H256.654V102.406L254.329 106.031Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 132.18H187.121V143.483H215.856V132.18Z",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.412 132.18H220.677V143.483H249.412V132.18Z",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.856 148.629H187.121V159.932H215.856V148.629Z",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.412 148.629H220.677V159.932H249.412V148.629Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.645 199.336H491.129C496.708 199.336 502.058 201.552 506.002 205.497C509.947 209.441 512.163 214.791 512.163 220.37V312.987H468.611V220.37C468.611 214.791 470.827 209.441 474.772 205.497C478.717 201.552 484.067 199.336 489.645 199.336Z",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.388 199.336V312.987",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.611 222.191H512.163",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.611 244.934H512.163",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.611 267.668H512.163",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.611 290.402H512.163",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.639 196.994H540.633C534.272 195.724 528.169 193.392 522.583 190.095C510.126 182.741 498.972 169.987 489.519 149.938H555.525C569.337 179.249 586.794 192.983 606.639 196.994Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.494 75.9844H394.671L444.733 120.031H366.556L316.494 75.9844Z",
    fill: "white",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13 75.9844L433.194 120.031",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.372 75.9844L420.435 120.031",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.615 75.9844L407.676 120.031",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.856 75.9844L394.918 120.031",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.096 75.9844L382.159 120.031",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.431 120.031L316.494 75.9844H394.671",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.599 120.078V157.466L93.2368 213.148V381.3",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.066 51.6914C290.272 51.8315 285.533 50.6292 281.386 48.22C280.371 50.4403 278.781 52.3486 276.78 53.7472C274.779 55.1457 272.44 55.9836 270.007 56.1739C267.573 56.3642 265.132 55.9 262.938 54.8294C260.745 53.7589 258.877 52.121 257.529 50.0855C256.182 48.05 255.403 45.691 255.274 43.2532C255.145 40.8154 255.671 38.3875 256.796 36.2212C257.922 34.055 259.606 32.2292 261.675 30.9332C263.744 29.6373 266.122 28.9183 268.562 28.8509H268.67C270.588 28.8116 272.492 29.1765 274.259 29.9217C276.026 30.6669 277.616 31.7759 278.926 33.1763C277.804 31.3778 276.28 29.8644 274.474 28.7555C272.667 27.6467 270.628 26.9727 268.517 26.7868C268.517 26.7116 268.517 26.6397 268.517 26.5645C268.375 21.4536 269.753 16.4157 272.475 12.0878C275.197 7.75984 279.141 4.33628 283.809 2.25003C288.477 0.163771 293.659 -0.491472 298.699 0.367155C303.739 1.22578 308.411 3.55972 312.125 7.07382C315.839 10.5879 318.427 15.1243 319.562 20.1094C320.698 25.0945 320.33 30.3044 318.504 35.0802C316.679 39.856 313.478 43.9833 309.307 46.94C305.136 49.8968 300.182 51.5503 295.071 51.6914H295.066Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.422 63.1571C253.891 63.1571 255.891 61.1562 255.891 58.6879C255.891 56.2197 253.891 54.2188 251.422 54.2188C248.954 54.2188 246.953 56.2197 246.953 58.6879C246.953 61.1562 248.954 63.1571 251.422 63.1571Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.611 55.5638H592.199C592.197 54.5662 591.983 53.5803 591.57 52.6719C591.158 51.7635 590.556 50.9536 589.806 50.296C589.056 49.6383 588.174 49.1482 587.219 48.8583C586.265 48.5683 585.259 48.4852 584.27 48.6144L571.429 50.3058C570.749 50.3955 570.059 50.3391 569.402 50.1402C568.746 49.9414 568.14 49.6048 567.625 49.1529C567.109 48.701 566.696 48.1443 566.413 47.5199C566.13 46.8956 565.984 46.218 565.984 45.5325C565.984 44.5523 565.765 43.5845 565.344 42.6996C564.922 41.8146 564.309 41.0348 563.548 40.4169C562.787 39.799 561.898 39.3587 560.946 39.1279C559.993 38.8971 559.001 38.8817 558.042 39.0828L541.246 42.6176C540.193 42.8383 539.104 42.8214 538.059 42.5681C537.013 42.3147 536.037 41.8313 535.202 41.1531C534.366 40.4749 533.693 39.6189 533.23 38.6475C532.767 37.6761 532.527 36.6138 532.527 35.5378C532.527 31.2284 530.815 27.0955 527.768 24.0482C524.721 21.001 520.588 19.2891 516.278 19.2891C516.007 19.2891 515.737 19.2891 515.468 19.2891C508.023 19.4044 500.708 21.2278 494.004 24.4702L429.611 55.5638Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.611 381.303H714.399C714.399 381.303 714.399 302.063 642.982 300.534C586.449 299.324 592.204 348.73 551.633 349.378C531.262 349.703 468.611 323.062 468.611 381.303Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.394 374.787C685.396 376.985 685.11 379.173 684.542 381.297H635.988C635.061 377.841 634.883 374.228 635.465 370.698C636.048 367.168 637.377 363.803 639.364 360.828C641.351 357.854 643.951 355.337 646.988 353.448C650.026 351.558 653.432 350.339 656.979 349.872C660.526 349.404 664.132 349.7 667.555 350.738C670.979 351.776 674.142 353.533 676.831 355.892C679.521 358.25 681.677 361.156 683.153 364.415C684.63 367.673 685.394 371.209 685.394 374.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.266 349.652V380.958",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.433 350.598L660.266 359.041",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.432 353.078L660.266 369.088",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.391 359.77L675.096 369.958",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.38 359.039H652.144",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.328 371.84L645.508 381.026",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.266 374.138L684.418 367.438",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.748 351.809C168.955 351.809 186.957 319.306 186.957 279.211C186.957 239.117 168.955 206.613 146.748 206.613C124.541 206.613 106.539 239.117 106.539 279.211C106.539 319.306 124.541 351.809 146.748 351.809Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.748 230.559V380.952",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.489 239.992C154.489 241.216 154.396 241.904 153.881 243.014L148.533 254.566C147.361 257.093 146.754 259.845 146.754 262.63",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.359 257.191V262.979C134.359 267.029 135.939 270.919 138.762 273.823L142.422 277.59C145.196 280.442 146.748 284.263 146.747 288.242",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.773 286.148V294.263C158.773 297.834 157.458 301.281 155.08 303.945L149.878 309.771C147.863 312.029 146.748 314.949 146.748 317.976",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.795 306.875C129.795 309.363 130.513 311.798 131.863 313.888C133.213 315.978 135.138 317.634 137.406 318.656L141.453 320.481C143.029 321.193 144.367 322.344 145.306 323.796C146.245 325.249 146.746 326.941 146.747 328.671",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.358 275.352H169.434V279.428C169.434 281.191 168.734 282.882 167.487 284.128C166.241 285.375 164.55 286.075 162.787 286.075H158.709V281.998C158.709 281.125 158.881 280.261 159.215 279.454C159.549 278.648 160.039 277.915 160.656 277.298C161.274 276.681 162.007 276.191 162.813 275.857C163.62 275.523 164.485 275.351 165.358 275.352Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.137 233.598H161.371V233.832C161.371 235.595 160.67 237.285 159.424 238.532C158.177 239.778 156.487 240.479 154.724 240.479H154.49V240.245C154.49 238.482 155.19 236.791 156.437 235.544C157.683 234.298 159.374 233.598 161.137 233.598Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.226 283.865L152.326 283.654L152.538 283.755C154.128 284.515 155.352 285.875 155.94 287.537C156.527 289.2 156.431 291.027 155.671 292.618L155.57 292.829L155.359 292.728C153.768 291.968 152.544 290.608 151.957 288.946C151.369 287.284 151.466 285.456 152.226 283.865Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.105 243.698L138.311 243.579L138.428 243.782C139.309 245.308 139.548 247.123 139.092 248.826C138.635 250.528 137.521 251.98 135.995 252.862L135.792 252.979L135.675 252.776C134.794 251.25 134.555 249.436 135.011 247.734C135.466 246.031 136.579 244.58 138.105 243.698Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74 331.905L158.958 331.99L158.872 332.208C158.229 333.849 156.961 335.168 155.345 335.874C153.73 336.58 151.901 336.616 150.259 335.973L150.041 335.887L150.127 335.67C150.769 334.028 152.038 332.709 153.653 332.003C155.269 331.297 157.098 331.262 158.74 331.905Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.829 306.955L138.934 306.736L139.145 306.837C140.736 307.597 141.959 308.957 142.547 310.62C143.135 312.282 143.038 314.109 142.278 315.7L142.177 315.911L141.966 315.81C140.377 315.051 139.154 313.692 138.565 312.032C137.977 310.371 138.072 308.545 138.829 306.955Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.243 257.594H133.471C131.708 257.594 130.017 256.893 128.771 255.647C127.524 254.4 126.824 252.71 126.824 250.947V250.175H127.593C129.356 250.175 131.046 250.875 132.293 252.121C133.54 253.368 134.24 255.059 134.24 256.822V257.594H134.243Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.602 219.637L146.621 217.618L148.639 219.637C149.886 220.883 150.586 222.574 150.586 224.337C150.586 226.1 149.886 227.79 148.639 229.037L146.625 231.051L144.607 229.032C143.361 227.786 142.661 226.097 142.66 224.335C142.659 222.574 143.358 220.884 144.602 219.637Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.791 295.878L129.81 293.859L131.828 295.878C133.075 297.125 133.775 298.815 133.775 300.578C133.775 302.341 133.075 304.032 131.828 305.278L129.81 307.297L127.791 305.278C126.545 304.032 125.845 302.341 125.845 300.578C125.845 298.815 126.545 297.125 127.791 295.878Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.435 243.084L165.592 243.257L165.42 243.415C164.119 244.605 162.399 245.229 160.638 245.151C158.877 245.072 157.219 244.297 156.029 242.997L155.871 242.824L156.044 242.666C157.344 241.476 159.065 240.852 160.826 240.93C162.587 241.009 164.245 241.783 165.435 243.084Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.828 357.257C536.416 357.257 549.863 336.744 549.863 311.439C549.863 286.135 536.416 265.621 519.828 265.621C503.239 265.621 489.792 286.135 489.792 311.439C489.792 336.744 503.239 357.257 519.828 357.257Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.982 273.766V381.129",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.179 285.945C526.179 288.918 525.363 291.834 523.819 294.374L519.796 300.989C518.609 302.94 517.982 305.18 517.982 307.464",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.893 289.711V305.189C509.893 308.543 510.862 311.826 512.684 314.642L515.329 318.735C517.061 321.413 517.982 324.535 517.982 327.724",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.179 315.293V321.978C526.178 324.949 525.453 327.875 524.066 330.502L519.116 339.883C518.372 341.293 517.983 342.864 517.982 344.458",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.058 361.93H531.134V366.006C531.134 367.769 530.434 369.46 529.188 370.706C527.941 371.953 526.25 372.653 524.488 372.653H520.411V368.577C520.411 366.814 521.111 365.123 522.358 363.877C523.605 362.63 525.295 361.93 527.058 361.93Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.982 374.825L527.09 366.387",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.133 312.085L525.943 311.987C525.233 311.621 524.602 311.118 524.087 310.508C523.571 309.898 523.181 309.192 522.938 308.431C522.695 307.67 522.604 306.868 522.671 306.072C522.738 305.276 522.961 304.501 523.327 303.791L523.426 303.601L523.617 303.7C525.051 304.44 526.132 305.719 526.623 307.256C527.113 308.793 526.973 310.462 526.233 311.896L526.135 312.086L526.133 312.085Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.358 286.176L526.306 285.963C525.918 284.397 526.168 282.741 527.001 281.359C527.834 279.977 529.182 278.983 530.749 278.595L530.956 278.544L531.008 278.752C531.395 280.318 531.145 281.974 530.312 283.356C529.479 284.737 528.131 285.732 526.565 286.119L526.357 286.171L526.358 286.176Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.134 286.137L525.949 286.03C524.551 285.224 523.532 283.895 523.114 282.336C522.696 280.778 522.915 279.117 523.722 277.72L523.829 277.535L524.02 277.645C525.417 278.452 526.437 279.78 526.854 281.339C527.272 282.897 527.053 284.558 526.247 285.955L526.14 286.141L526.134 286.137Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.799 333.234L511.585 333.223C510.787 333.18 510.006 332.98 509.285 332.635C508.565 332.29 507.919 331.807 507.385 331.212C506.852 330.618 506.44 329.924 506.175 329.171C505.909 328.417 505.794 327.619 505.837 326.821L505.849 326.608L506.062 326.619C507.673 326.706 509.184 327.429 510.262 328.629C511.34 329.83 511.897 331.41 511.81 333.021L511.799 333.234Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.637 312.559L528.613 312.301C528.43 310.365 529.023 308.436 530.263 306.938C531.502 305.44 533.285 304.496 535.221 304.313L535.479 304.288L535.503 304.546C535.686 306.482 535.093 308.411 533.854 309.909C532.614 311.407 530.831 312.351 528.895 312.534L528.637 312.559Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.991 332.75L511.808 332.567C510.433 331.192 509.661 329.328 509.661 327.383C509.661 325.439 510.433 323.575 511.808 322.2L511.991 322.017L512.174 322.2C513.549 323.575 514.321 325.439 514.321 327.383C514.321 329.328 513.549 331.192 512.174 332.567L511.991 332.75Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.781 298.363V299.508C503.781 300.395 504.133 301.245 504.76 301.872C505.387 302.499 506.237 302.851 507.123 302.851C507.86 302.851 508.567 303.143 509.088 303.664C509.609 304.185 509.901 304.892 509.901 305.629",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.427 283.547H318.562V284.76C318.562 287.252 317.572 289.641 315.811 291.403C314.049 293.165 311.659 294.155 309.168 294.155H245.23V291.741C245.23 290.665 245.441 289.599 245.853 288.604C246.265 287.61 246.868 286.706 247.63 285.945C248.391 285.184 249.295 284.58 250.289 284.169C251.284 283.757 252.35 283.546 253.427 283.547Z",
    fill: "#3503A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.036 392.1C473.242 392.1 484.758 380.584 484.758 366.378C484.758 352.172 473.242 340.656 459.036 340.656C444.831 340.656 433.314 352.172 433.314 366.378C433.314 380.584 444.831 392.1 459.036 392.1Z",
    fill: "#3503A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.261 381.551C434.513 376.411 432.802 370.064 433.46 363.736C434.118 357.408 437.097 351.549 441.822 347.289C446.548 343.029 452.684 340.672 459.046 340.672C465.408 340.672 471.544 343.029 476.269 347.289L438.261 381.551Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.036 373.75C463.105 373.75 466.403 370.452 466.403 366.383C466.403 362.314 463.105 359.016 459.036 359.016C454.967 359.016 451.669 362.314 451.669 366.383C451.669 370.452 454.967 373.75 459.036 373.75Z",
    stroke: "white",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19 392.1C238.396 392.1 249.912 380.584 249.912 366.378C249.912 352.172 238.396 340.656 224.19 340.656C209.984 340.656 198.468 352.172 198.468 366.378C198.468 380.584 209.984 392.1 224.19 392.1Z",
    fill: "#3503A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.801 358.181C201.747 352.399 205.685 347.496 210.911 344.349C216.138 341.201 222.313 340.013 228.334 340.997C234.355 341.981 239.831 345.073 243.783 349.721C247.736 354.369 249.908 360.27 249.911 366.371L199.801 358.181Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.201 373.75C228.27 373.75 231.568 370.452 231.568 366.383C231.568 362.314 228.27 359.016 224.201 359.016C220.132 359.016 216.833 362.314 216.833 366.383C216.833 370.452 220.132 373.75 224.201 373.75Z",
    stroke: "white",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36 243.163C422.36 246.076 421.324 248.895 419.435 251.114C417.547 253.334 414.931 254.809 412.055 255.275C409.178 255.741 406.23 255.169 403.737 253.66C401.245 252.151 399.37 249.805 398.45 247.04L419.156 234.895C421.221 237.152 422.364 240.103 422.36 243.163Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.157 234.897L398.451 247.043C397.561 244.375 397.616 241.482 398.605 238.849C399.594 236.217 401.457 234.004 403.883 232.581C406.309 231.158 409.15 230.612 411.93 231.033C414.711 231.455 417.262 232.819 419.157 234.897Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.909 363.851V294.156H249.743C214.803 294.156 185.73 321.017 182.981 355.847H243.149C247.197 355.848 251.199 356.7 254.896 358.348C258.593 359.997 261.901 362.405 264.606 365.416L273.359 375.158C275.095 377.092 277.219 378.638 279.592 379.697C281.965 380.755 284.535 381.302 287.134 381.302H407.485C412.257 381.302 416.941 380.029 421.057 377.615L486.107 339.45C486.107 339.45 479.047 316.695 449.712 322.79L399.435 240.545C398.517 239.045 397.23 237.805 395.696 236.945C394.162 236.085 392.434 235.633 390.675 235.633H381.332V240.135H385.278C387.254 240.135 389.187 240.704 390.847 241.774C392.507 242.845 393.823 244.371 394.638 246.171L425.337 314.045C437.976 341.982 417.547 373.645 386.885 373.645H307.698C306.412 373.645 305.139 373.392 303.951 372.9C302.763 372.408 301.683 371.686 300.774 370.777C299.865 369.867 299.144 368.787 298.653 367.599C298.161 366.411 297.908 365.137 297.909 363.851Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.951 355.686C191.721 338.638 206.517 325.613 224.352 325.613C244.161 325.613 260.219 341.672 260.219 361.48",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.024 322.633C442.859 324.702 436.956 329.378 433.632 335.45",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.811 241.144C384.64 241.144 386.933 238.85 386.933 236.021C386.933 233.192 384.64 230.898 381.811 230.898C378.982 230.898 376.688 233.192 376.688 236.021C376.688 238.85 378.982 241.144 381.811 241.144Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.731 201.377C390.227 196.656 391.607 191.753 389.814 190.425C388.021 189.098 383.734 191.848 380.238 196.569C376.742 201.29 375.362 206.193 377.155 207.521C378.948 208.849 383.235 206.098 386.731 201.377Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.465 200.299C389.072 195.427 390.496 190.367 388.646 188.997C386.795 187.626 382.37 190.464 378.763 195.336C375.155 200.207 373.731 205.267 375.582 206.638C377.433 208.008 381.858 205.17 385.465 200.299Z",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.207 237.256V217.551C396.207 214.865 395.212 212.275 393.414 210.28L382.298 197.949",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.911 294.156V305.573L245.232 294.323V294.312C246.723 294.209 248.227 294.158 249.745 294.16L297.911 294.156Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.189 392.102H509.893",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.853 401.148H486.107",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.506 366.428C179.002 359.889 175.326 354.054 170.077 349.875C164.828 345.696 158.317 343.421 151.608 343.422C145.931 343.422 140.365 341.848 135.528 338.875C130.692 335.902 126.774 331.646 124.211 326.58L115.873 310.094C111.897 302.233 105.387 295.942 97.3951 292.236C89.4032 288.531 80.3956 287.627 71.8267 289.67C63.2579 291.714 55.6279 296.586 50.1687 303.5C44.7095 310.414 41.7399 318.966 41.7392 327.775V334.007C46.3636 334.322 50.8272 335.832 54.694 338.388C58.5608 340.944 61.6986 344.459 63.8009 348.59C61.2934 345.441 58.1074 342.899 54.4804 341.153C50.8535 339.407 46.8792 338.502 42.854 338.506C42.4813 338.506 42.1085 338.515 41.7392 338.53C34.8284 338.814 28.2951 341.758 23.5057 346.749C18.7164 351.739 16.042 358.387 16.042 365.304C16.042 372.22 18.7164 378.869 23.5057 383.859C28.2951 388.849 34.8284 391.794 41.7392 392.078L220.111 392.101C195.441 392.096 183.964 381.451 180.506 366.428ZM38.3062 355.593C37.6273 355.593 36.9636 355.391 36.399 355.014C35.8345 354.637 35.3945 354.101 35.1346 353.473C34.8748 352.846 34.8068 352.156 34.9393 351.49C35.0717 350.824 35.3987 350.212 35.8788 349.732C36.3589 349.252 36.9706 348.925 37.6365 348.793C38.3024 348.66 38.9927 348.728 39.62 348.988C40.2473 349.248 40.7834 349.688 41.1606 350.252C41.5378 350.817 41.7392 351.481 41.7392 352.16C41.7392 353.07 41.3775 353.943 40.7337 354.587C40.0899 355.231 39.2167 355.593 38.3062 355.593Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69645 391.363C10.0628 391.363 12.7918 388.634 12.7918 385.267C12.7918 381.901 10.0628 379.172 6.69645 379.172C3.33007 379.172 0.601074 381.901 0.601074 385.267C0.601074 388.634 3.33007 391.363 6.69645 391.363Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.954 360.95C365.377 366.168 346.516 362.725 341.55 361.644C341.567 361.605 341.584 361.565 341.602 361.525L382.787 276.621V356.267C382.789 357.9 383.19 359.507 383.954 360.95Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.555 372.115V373.638H349.019C342.835 373.638 338.712 367.275 341.204 361.643C346.176 362.724 365.031 366.167 383.608 360.949C384.291 362.237 385.247 363.36 386.409 364.24L388.384 365.744C389.369 366.489 390.168 367.452 390.718 368.558C391.268 369.663 391.554 370.881 391.555 372.115Z",
    fill: "#3503A3",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26 283.29L344.203 357.725C343.557 359.061 343.438 360.59 343.868 362.01C343.868 362.01 320.725 371.37 299.202 368.589C298.454 367.265 298.025 365.785 297.947 364.267C297.87 362.749 298.147 361.234 298.756 359.841L328.8 290.313C329.142 289.521 329.282 288.657 329.207 287.798C329.132 286.939 328.845 286.111 328.371 285.391C327.898 284.67 327.252 284.078 326.493 283.669C325.734 283.259 324.885 283.045 324.023 283.044H280.902C277.024 283.044 273.19 282.214 269.658 280.61C266.127 279.006 262.979 276.666 260.427 273.745L318.668 247.453H357.801C376.216 247.451 388.288 266.712 380.26 283.29Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.259 257.852C351.674 257.852 363.746 277.114 355.718 293.685L319.661 368.12",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.34 3.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.702 373.636H307.824C306.065 373.642 304.337 373.176 302.819 372.287C301.302 371.397 300.051 370.116 299.197 368.578C320.72 371.355 343.863 362 343.863 362C344.167 363.012 344.737 363.923 345.515 364.639L347.61 366.578C348.586 367.477 349.364 368.568 349.896 369.783C350.428 370.998 350.703 372.31 350.702 373.636Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.953 170.98L323.839 178.236C320.706 176.083 316.993 174.934 313.192 174.94H305.287C304.861 174.94 304.436 174.946 304.012 174.96L315.168 164.805L328.953 170.98Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.924 157.927L334.169 165.58C334.219 166 334.113 166.423 333.873 166.771C333.633 167.119 333.274 167.368 332.864 167.47L332.759 167.495C332.35 167.595 331.981 167.816 331.7 168.129C331.419 168.442 331.239 168.833 331.184 169.25L330.85 171.794C330.78 172.319 330.505 172.796 330.085 173.119C329.665 173.442 329.134 173.586 328.609 173.519C325.739 173.136 320.638 171.761 319.226 166.813C317.229 159.817 324.668 157.922 324.668 157.922L332.924 157.927Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53 160.555C326.53 160.555 328.153 159.607 329.587 159.582",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 163.803C328.994 163.803 329.226 163.392 329.226 162.884C329.226 162.376 328.994 161.965 328.708 161.965C328.421 161.965 328.189 162.376 328.189 162.884C328.189 163.392 328.421 163.803 328.708 163.803Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.131 169.345C329.182 169.345 328.77 167.449 328.77 167.449",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.179 163.919L313.95 163.418C312.845 161.011 312.741 158.265 313.659 155.781C314.578 153.298 316.444 151.281 318.849 150.172L320.131 149.581C321.273 149.054 322.516 148.781 323.774 148.781C325.032 148.782 326.275 149.055 327.417 149.583C328.559 150.11 329.573 150.879 330.388 151.837C331.204 152.795 331.802 153.918 332.141 155.13L332.923 157.921H326.622C325.81 157.921 325.031 158.243 324.457 158.817C323.883 159.392 323.56 160.171 323.56 160.983V162.002C323.56 163.22 323.077 164.388 322.216 165.249C321.355 166.11 320.187 166.593 318.969 166.593H318.351C317.472 166.593 316.613 166.342 315.873 165.868C315.134 165.394 314.546 164.717 314.179 163.919Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.68 174.973C326.634 174.973 326.589 174.97 326.544 174.965C325.521 174.838 323.253 174.214 321.234 172.682C318.784 170.82 317.578 168.276 317.743 165.328C317.759 165.04 317.889 164.77 318.104 164.578C318.32 164.385 318.602 164.286 318.89 164.302C319.179 164.319 319.448 164.449 319.641 164.664C319.833 164.879 319.932 165.162 319.916 165.45C319.618 170.761 325.373 172.637 326.815 172.804C327.103 172.821 327.373 172.953 327.564 173.169C327.755 173.385 327.853 173.668 327.835 173.956C327.818 174.244 327.687 174.514 327.471 174.705C327.254 174.896 326.971 174.994 326.683 174.976L326.68 174.973Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.886 165.332C320.376 165.332 321.585 164.124 321.585 162.633C321.585 161.142 320.376 159.934 318.886 159.934C317.395 159.934 316.187 161.142 316.187 162.633C316.187 164.124 317.395 165.332 318.886 165.332Z",
    stroke: "white",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.29 158.373C323.99 158.61 327.989 156.924 330.805 155.419C330.635 154.953 330.547 154.46 330.548 153.964C330.548 151.515 332.615 149.531 335.164 149.531C337.713 149.531 339.782 151.515 339.782 153.964C339.782 156.412 337.715 158.394 335.164 158.394L325.29 158.373Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.682 155.273C343.579 155.273 344.307 154.545 344.307 153.648C344.307 152.751 343.579 152.023 342.682 152.023C341.785 152.023 341.058 152.751 341.058 153.648C341.058 154.545 341.785 155.273 342.682 155.273Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.968 248.207C363.968 248.207 321.932 271.374 299.339 256.181C299.339 256.181 277.792 270.81 260.428 273.747V233.11C260.428 224.558 264.251 211.802 268.451 200.368C271.247 192.761 276.311 186.196 282.959 181.558C289.606 176.921 297.516 174.435 305.621 174.438H313.533C318.529 174.438 323.32 176.422 326.852 179.954C330.385 183.487 332.369 188.278 332.369 193.274V214.869C332.369 215.528 332.515 216.18 332.795 216.776C333.076 217.373 333.485 217.9 333.993 218.321C334.501 218.741 335.096 219.045 335.734 219.209C336.373 219.373 337.04 219.394 337.688 219.271L362.816 214.491C360.755 216.497 359.23 223.695 359.23 231.45C359.226 240.598 361.349 248.207 363.968 248.207Z",
    fill: "#0047FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.874 231.45C367.874 240.597 365.751 248.207 363.132 248.207C360.513 248.207 358.391 240.597 358.391 231.45C358.391 222.303 360.513 214.773 363.132 214.773C365.751 214.773 367.874 222.303 367.874 231.45Z",
    fill: "white",
    stroke: "#0047FF",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.197 222.567V238.957H389.879C389.099 238.957 388.352 238.647 387.801 238.096C387.25 237.545 386.94 236.798 386.94 236.018C386.94 234.66 386.401 233.357 385.441 232.396C384.48 231.435 383.178 230.895 381.819 230.894C380.461 230.895 379.159 231.436 378.198 232.396C377.238 233.357 376.698 234.66 376.697 236.018C376.697 237.619 376.382 239.203 375.77 240.682C375.158 242.161 374.26 243.504 373.129 244.636C371.997 245.768 370.654 246.665 369.175 247.277C367.696 247.89 366.111 248.204 364.511 248.204H363.978H363.853C361.292 247.965 359.236 240.456 359.236 231.452C359.236 227.329 359.669 223.535 360.381 220.612L366.649 217.697L370.15 216.069C371.953 215.231 373.979 215.002 375.923 215.416L388.583 218.107C389.605 218.325 390.521 218.887 391.178 219.698C391.836 220.51 392.195 221.523 392.197 222.567Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.316 222.848L388.576 224.603C389.599 224.821 390.516 225.383 391.174 226.197C391.832 227.01 392.191 228.024 392.191 229.07V238.796",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.709 231.449C368.709 240.598 366.587 248.206 363.968 248.206H363.842C361.282 247.967 359.226 240.458 359.226 231.454C359.226 227.331 359.659 223.537 360.371 220.614L366.638 217.699C367.89 220.709 368.709 225.767 368.709 231.449Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.096 258.221C294.148 253.04 286.54 244.546 288.794 218.906",
    stroke: "white",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.555 258.13C287.763 273.473 260.428 273.74 260.428 273.74V244.535C261.485 264.011 290.813 253.803 294.749 252.354C296.746 254.76 299.195 256.575 301.555 258.13Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.272 173.914V174.434C296.07 174.916 287.278 178.391 280.233 184.33C273.189 190.27 268.278 198.348 266.248 207.336L260.428 233.106V173.914H305.272Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.427 174.434V273.745H212.794C205.775 273.745 199.9 268.455 198.472 261.395C198.25 260.299 198.138 259.184 198.138 258.066V190.111C198.138 190.076 198.138 190.039 198.138 190.002C198.146 188.291 198.418 186.591 198.945 184.963C200.936 178.833 206.381 174.434 212.789 174.434H260.427Z",
    fill: "white",
    stroke: "#0D0225",
    strokeWidth: 0.83567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.427 257.164V262.203H198.474C198.252 261.181 198.14 260.137 198.14 259.091V257.164H260.427Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.427 184.965V190.004H198.153C198.161 188.293 198.433 186.593 198.961 184.965H260.427Z",
    fill: "#0D0225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.909 191.531H198.648V192.367H259.909V191.531Z",
    fill: "#1977F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_1158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 713.798,
    height: 401.563,
    fill: "white",
    transform: "translate(0.601074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateillustrate);
export default __webpack_public_path__ + "static/media/Lateillustrate.d515dba932f2c87e9cb282fe451daef6.svg";
export { ForwardRef as ReactComponent };